var _defs, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSms2Ublue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        font-family: HelveticaNeue-CondensedBold, 'Helvetica Neue';\r\n        font-size: 119.2px;\r\n        font-weight: 700;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #4dace0;\r\n      }\r\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(7.5 285.4) scale(1.4 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st1",
    x: 0,
    y: 0
  }, "SMS"), /*#__PURE__*/React.createElement("tspan", {
    x: 211.9,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    className: "st1",
    x: 269.1,
    y: 0
  }, "U"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms2Ublue);
export default __webpack_public_path__ + "static/media/SMS2ublue.20191b0e31565b18d72140a1ec3ab889.svg";
export { ForwardRef as ReactComponent };